import React, { FunctionComponent } from 'react';
import { MetaTagsList } from './MetaTagsList';
import { useQueryStaticMetaTags } from '../hooks/useQueryMetaTags';

interface Props {
  requestUrl: string;
  queryOptions?: any;
  translate?(key: string): string;
  format?(html: string): string;
}

export const StaticMetaTags: FunctionComponent<Props> = ({
  requestUrl,
  translate = key => key,
  format = html => html,
  queryOptions,
}) => {
  const { isSuccess, data } = useQueryStaticMetaTags(requestUrl, queryOptions);

  // @ts-ignore
  return isSuccess ? <MetaTagsList data={data} translate={translate} format={format} /> : null;
};
